export default {
  title: 'Facturi',
  table: {
    id_mb: 'ID MB',
    id_bou: 'ID BOU',
    client_id: 'ID client',
    client_name: 'Nume client',
    period: 'Perioada facturata',
    created_at: 'Data creeare factura',
    status: 'Status',
    total: 'Valoare totala',
    type: 'Tip factura',
    types: {
      1: 'Factura standard',
      2: 'Factura storno'
    },
    source: 'Sursa',
    sources: {
      1: 'Sistem',
      2: 'Manual'
    },
    status_list: {
      1: 'In asteptare',
      2: 'Eroare',
      10: 'Facturat',
      11: 'Anulat',
      12: 'Stornat'
    },
    filters: {
      invoice_name: 'Numar factura',
      client: 'Client',
      invoice_status: 'Status factura'
    }

  },
  invoice_details: {
    title: 'Detalii',
    details: 'Detalii factura',
    requests: 'Solicitari incluse in factura',

    subscription: {
      type: 'Tip subscriptie',
      users: 'Nr utilizatori'
    },
    details_data: {
      invoice_id: 'Numar factura',
      client_id: 'Cod client',
      client_name: 'Nume client',
      start_date: 'Data emitere',
      status: 'Status',
      details: 'Descriere',
      details_invoice: 'Descriere factura storno',
      filters: {
        title: 'Filtre',
        benefit: 'Tip beneficiu',
        partner: 'Partener',
        company: 'Companie'
      },
      buttons: {
        select: 'Selectare',
        save: 'Salveaza tva',
        create: 'Trimite factura',
        credit: 'Storneaza selectia',
        credit_all: 'Storneaza total',
        download_invoice: 'Descarca factura',
        apply_filters: 'Aplica filtrele',
        add_subscription: 'Adauga subscriptie'
      }
    },
    table: {
      order_request_id: 'Nr. Solicitare',
      placed_at: 'Plasat la data',
      company_employee: 'Beneficiar',
      client: 'Client',
      benefit_name: 'Nume beneficiu',
      status: 'Status',
      status_invoice: 'Status facturare',
      partner: 'Partener',
      quantity: 'Cantitate',
      value: 'Valoare',
      vat: 'TVA',
      vat_value: 'Valoare TVA',
      benefit_sub_type: 'Tip'
    }
  },
  invoice_create: {
    total: 'Suma totala:',
    total_vat: 'Total tva:',
    buttons: {
      create: 'Adauga factura'
    },
    subscription: {
      title: 'Subscriptie',
      invoice_settings: 'Setari pentru facturi automate',
      users: 'Nr. utilizatori',
      company: 'Subscriptie tip companie'
    }
  },
  alert_messages: {
    credit: {
      success: 'Stornare efectuata cu success'
    },
    invoice_create: {

    }
  }
}
